// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f6354f97","453":"9d8ba75a","455":"6ea04e93"}[chunkId] + ".chunk.js";
};